import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils/cn';

/**
 * Surface container matching the website widget card: white background,
 * soft 0.45rem radius, and the signature `4px 4px 30px rgba(75,102,171,.2)`
 * shadow.
 */
export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('rounded-card bg-surface shadow-card', className)}
      {...props}
    />
  );
}
